import ascending from "./ascending";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/order/descending.js
// module id = ../../../../d3-shape/src/order/descending.js
// module chunks = 4